// extracted by mini-css-extract-plugin
export default {"advertising-content":"Advertising_advertising-content__nxGLa","title-advertising":"Advertising_title-advertising__BMbrd"};